import { applyAdminRagImport, previewAdminRagImport } from '@/lib/api/admin';
import ItemsImportDialog from '@/components/knowledge-base/items-import-dialog';

const RAG_IMPORT_COPY = {
  description:
    'The server parses the file, computes a diff against the live collection, and only mutates Mongo + Qdrant once you confirm.',
  xlsxHint: 'Start from Export → Excel workbook: one sheet per section, and rows with an empty ID get one on import.',
  mdHint: 'Accepts the same format used by `temp/rag/straits_eye_clinics_qa.md`.',
  itemNouns: ['item', 'items'],
  fields: { section: 'Section', question: 'Question', aliases: 'Aliases', answer: 'Answer' },
};

function RagImportDialog(props) {
  return (
    <ItemsImportDialog
      {...props}
      previewImport={previewAdminRagImport}
      applyImport={applyAdminRagImport}
      copy={RAG_IMPORT_COPY}
    />
  );
}

export default RagImportDialog;
